import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getUnemployedJobPosts = async (HubIds: string[]) => {
    const { path, method } = endpoints.laborDemandPulse.getUnemployedJobPosts;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
